import { Box, Card, CardContent, DialogContent, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { Fragment } from "react";
import appConfig from "src/config/env";
import useAuthGlobal from "src/context/useAuthGlobal";
import useWarehouseDetailDistribution from "src/hooks/warehouse/useWarehouseDetailDistribution";

export default function WarehouseDistributionDetail({ item }) {
  const { userMe } = useAuthGlobal();
  const { data } = useWarehouseDetailDistribution({ id: userMe?.currentWarehouse?._id, product: item?.product?._id });

  return (
    <DialogContent>
      <Stack>
        <Box
          display="flex"
          gap={2}
          mb={2}
        >
          <Box
            sx={{
              background: `url(${appConfig.API_FILE}/${data?.data[0]?.product?.imageUrl})`,
              height: "45px",
              width: "45px",
              border: 1,
              borderRadius: "6px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          />
          <Typography fontWeight={600}>{data?.data[0]?.product?.name}</Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{ fontWeight: 600 }}
                >
                  Phân loại
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: 600 }}
                >
                  Kho con
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: 600 }}
                >
                  Tỉ lệ
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data?.data[0]?.productModels?.map((model) =>
                model.childWarehouses.map((warehouse, index) => (
                  <TableRow key={`${model._id}-${warehouse.childWarehouse?._id}`}>
                    {index === 0 && (
                      <TableCell
                        align="center"
                        rowSpan={model.childWarehouses.length}
                      >
                        {model.name}
                      </TableCell>
                    )}

                    <TableCell align="center">{warehouse.childWarehouse?.name}</TableCell>

                    <TableCell align="center">{warehouse.percentage}%</TableCell>
                  </TableRow>
                )),
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </DialogContent>
  );
}
